module.exports = __webpack_public_path__ + "media/acuity/angle_down-38f09079.png";